/**
 * Файл генерируется автоматически командой `npm run generate:advanced-filter`.
 * Не стоит его изменять руками, если вы не уверены в том, что делаете :)
 */
import { IFilter, TFilter } from '../../types/advancedFilters';
import { apartments } from './apartments';
import { balcony } from './balcony';
import { bathType } from './bathType';
import { bedrooms } from './bedrooms';
import { ceilingHeight } from './ceilingHeight';
import { completionYear } from './completionYear';
import { constructionType } from './constructionType';
import { constructionYear } from './constructionYear';
import { contact } from './contact';
import { containWords } from './containWords';
import { dealType } from './dealType';
import { decorationsList } from './decorationsList';
import { demolition } from './demolition';
import { elevators } from './elevators';
import { excludeWords } from './excludeWords';
import { facilities } from './facilities';
import { finishing } from './finishing';
import { flatRooms } from './flatRooms';
import { floor } from './floor';
import { floors } from './floors';
import { fromMKAD } from './fromMKAD';
import { garageStatus } from './garageStatus';
import { garageType } from './garageType';
import { garageUtilities } from './garageUtilities';
import { heatingType } from './heatingType';
import { kitchenStove } from './kitchenStove';
import { landStatus } from './landStatus';
import { layout } from './layout';
import { livingConditions } from './livingConditions';
import { offerId } from './offerId';
import { offerType } from './offerType';
import { parking } from './parking';
import { possessor } from './possessor';
import { publicationDate } from './publicationDate';
import { rentTerms } from './rentTerms';
import { rentalPeriod } from './rentalPeriod';
import { repair } from './repair';
import { roomsInDeal } from './roomsInDeal';
import { saleType } from './saleType';
import { squareMeterArea } from './squareMeterArea';
import { suburbanArea } from './suburbanArea';
import { suburbanAreaDailyrent } from './suburbanAreaDailyrent';
import { suburbanBathroom } from './suburbanBathroom';
import { suburbanFacilities } from './suburbanFacilities';
import { suburbanHouseType } from './suburbanHouseType';
import { suburbanUtilities } from './suburbanUtilities';
import { undergroundTime } from './undergroundTime';
import { urbanBathroom } from './urbanBathroom';
import { windows } from './windows';
import { withNeighbors } from './withNeighbors';
/* marker: prepend import */

export const ADVANCED_FILTERS: { [key in TFilter]: IFilter } = {
  apartments,
  balcony,
  bathType,
  ceilingHeight,
  completionYear,
  constructionType,
  constructionYear,
  contact,
  containWords,
  dealType,
  demolition,
  elevators,
  excludeWords,
  facilities,
  finishing,
  flatRooms,
  floor,
  floors,
  fromMKAD,
  garageType,
  garageStatus,
  garageUtilities,
  heatingType,
  kitchenStove,
  landStatus,
  layout,
  livingConditions,
  offerId,
  offerType,
  parking,
  publicationDate,
  rentTerms,
  rentalPeriod,
  repair,
  roomsInDeal,
  saleType,
  squareMeterArea,
  suburbanArea,
  suburbanAreaDailyrent,
  suburbanBathroom,
  suburbanFacilities,
  suburbanHouseType,
  suburbanUtilities,
  undergroundTime,
  urbanBathroom,
  windows,
  withNeighbors,
  bedrooms,
  decorationsList,
  possessor,
  /* marker: prepend key */
};
